const HOVER_LUMINANCE = 2.5;
const ACTIVE_LUMINANCE = 5;
export { HOVER_LUMINANCE, ACTIVE_LUMINANCE };